import type { IGLMenuItem } from '@group-link-one/gl-components';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { SettingsRoutes } from '../enums/enums';
import { useMainLayoutTranslate } from './useMainLayoutTranslate';
import { usePrivileges } from '@/hooks/usePrivilleges';
import { verifyIfPathIsActives } from '@/utils/verifyIfPathIsActive';

interface GetTopbarAddonsItems {
  settings: IGLMenuItem[];
  getTopbarAddonsItems: () => IGLMenuItem[];
}

export function useGetTopbarAddonsItems(): GetTopbarAddonsItems {
  const navigate = useNavigate();
  const location = useLocation();

  const { pages } = usePrivileges();

  const { customLocale } = useMainLayoutTranslate();

  const settings: IGLMenuItem[] = useMemo(() => {
    const items: IGLMenuItem[] = [
      {
        id: '1',
        label: customLocale('settings.overview', 'Overview'),
        active: verifyIfPathIsActives(SettingsRoutes.OVERVIEW, true),
        isToAppear: pages.settings.overview,
        dropdown: true,
        onClick: () => navigate(SettingsRoutes.OVERVIEW),
      },
      {
        id: '2',
        label: customLocale('settings.myAccount', 'My Account'),
        active: verifyIfPathIsActives(SettingsRoutes.MY_ACCOUNT, true),
        isToAppear: pages.settings.myAccount,
        onClick: () => navigate(SettingsRoutes.MY_ACCOUNT),
      },
      {
        id: '3',
        label: customLocale('settings.loginSecurity', 'Login & Security'),
        active: verifyIfPathIsActives(SettingsRoutes.LOGIN_SECURITY, true),
        isToAppear: pages.settings.loginSecurity,
        onClick: () => navigate(SettingsRoutes.LOGIN_SECURITY),
      },
      {
        id: '4',
        label: customLocale('settings.users', 'Users'),
        active: verifyIfPathIsActives(SettingsRoutes.USERS, true),
        isToAppear: pages.settings.users,
        onClick: () => navigate(SettingsRoutes.USERS),
      },
    ];

    return items.filter(item => item.isToAppear);
  }, [navigate, customLocale, pages.settings]);

  function getTopbarAddonsItems(): IGLMenuItem[] {
    const locationPath = location.pathname;

    if (locationPath.includes('settings')) return settings;

    return [];
  }

  return {
    settings,
    getTopbarAddonsItems,
  };
}
